import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { countryList } from '@savgroup-front-common/core/domains/i18n/selectors';
import { BaseAutocompleteOption } from '@savgroup-front-common/types';

import {
  CustomerInformationAddressValues,
  HandleSelectAddressValues,
} from '../CustomerInformationAddress.types';

interface UseHandleSelectAddressArgs {
  formContext: UseFormReturn<CustomerInformationAddressValues>;
}

interface UseHandleSelectAddressReturnValues {
  countryOptions: BaseAutocompleteOption[];
  handleSelectAddress: (address: HandleSelectAddressValues) => void;
}

const useHandleSelectAddress = ({
  formContext,
}: UseHandleSelectAddressArgs): UseHandleSelectAddressReturnValues => {
  const { setValue } = formContext;
  const countryOptions = useSelector(countryList);

  const handleSelectAddress = useCallback(
    ({ countryCode, city, postalCode }: HandleSelectAddressValues = {}) => {
      setValue(
        'countryCode',
        countryOptions.filter((country) => country.value === countryCode)[0],
      );
      setValue('city', city || '');
      setValue('postalCode', postalCode || '');
    },
    [countryOptions, setValue],
  );

  return {
    countryOptions,
    handleSelectAddress,
  };
};

export default useHandleSelectAddress;
